import { isShampooRange, isConditioner, shampooNeed } from "./shampoos";

const SHIP = "Livraison gratuite en Point Relais Mondial Relay partout en France, dès 11,90 € dans les DOM-TOM, 4,99 € en Europe.";

export const COLLECTIONS = {
  shampoings: {
    path: "/shampoings",
    name: "Shampoings",
    h1Sub: "pour cheveux afro, crépus et locks",
    eyebrow: "La gamme lavante",
    title: "Shampoings pour cheveux, locks et barbe | Ozentya",
    description: "Shampoings Ozentya pour la pousse des cheveux, les locks, la barbe et toute la famille, et notre après-shampoing Ricin & Jojoba. Formats 250 ml. Livraison gratuite en Point Relais.",
    intro: `Le lavage est la première étape de votre rituel. Nos shampoings nettoient en douceur le cuir chevelu, les locks ou la barbe, avec des formules adaptées à chaque besoin : pousse et fortification, cuir chevelu sujet aux pellicules, locks, barbe et cheveux des enfants. Complétez avec notre après-shampoing pour faciliter le démêlage. ${SHIP}`,
    match: isShampooRange,
    sections: [
      { id: "shampoings", title: "Nos shampoings", filter: (p) => !isConditioner(p) },
      { id: "apres-shampoing", title: "Après-shampoing", filter: isConditioner },
    ],
    needs: shampooNeed,
    guideTitle: "Bien choisir votre shampoing",
    cols: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  },
  gels: {
    path: "/gels",
    name: "Gels",
    h1Sub: "coiffants pour boucles et locks",
    eyebrow: "Définir & fixer",
    title: "Gels coiffants pour boucles et locks | Ozentya",
    description: "Gels coiffants Ozentya : Gel Définition Boucles à l'aloe vera et à la kératine pour cheveux bouclés, frisés et crépus, et Gel Locks pour retwister et fixer vos locks. Livraison gratuite en Point Relais en France.",
    intro: `Pour définir et tenir la coiffure. Le Gel Définition Boucles, à l'aloe vera et à la kératine, hydrate et dessine les boucles des cheveux bouclés, frisés et crépus sans les alourdir, en limitant les frisottis. Le Gel Locks permet de retwister, discipliner et fixer les locks, dreadlocks et starter locks, avec une tenue nette qui respecte le cuir chevelu. ${SHIP}`,
    match: (p) => (p.collections || []).includes("gels"),
    manual: true,
    order: ["gel-definition-boucles", "gel-locks"],
    sections: [{ id: "gels", title: "Nos gels", filter: () => true }],
    cols: "sm:grid-cols-2 md:grid-cols-3",
  },
  "cremes-coiffantes": {
    path: "/cremes-coiffantes",
    name: "Crèmes coiffantes",
    h1Sub: "pour cheveux afro et crépus",
    eyebrow: "Coiffer & sublimer",
    title: "Crèmes coiffantes et Edge Control | Ozentya",
    description: "Crèmes coiffantes Ozentya : Crème Reconstructrice Cactus, Crème Démêlante Junior et Edge Control pour des contours nets. Livraison gratuite en Point Relais en France.",
    intro: `Après le soin, place au coiffage. Notre Crème Reconstructrice Cactus prend soin des cheveux fragilisés et les sublime, la Crème Démêlante Junior dit stop aux nœuds pour un coiffage facile des enfants, et l'Edge Control offre une fixation forte pour des contours nets, tout en les soignant. ${SHIP}`,
    match: (p) => (p.collections || []).includes("cremes-coiffantes"),
    manual: true,
    order: ["creme-reconstructrice-cactus", "creme-demelante-junior", "edge-control"],
    sections: [{ id: "cremes", title: "Nos crèmes coiffantes", filter: () => true }],
    cols: "sm:grid-cols-2 md:grid-cols-3",
  },
  masques: {
    path: "/masques",
    name: "Masques",
    h1Sub: "pour cheveux afro et crépus",
    eyebrow: "Le soin profond",
    title: "Masques capillaires hydratants et démêlants | Ozentya",
    description: "Masques capillaires Ozentya : Masque Suprême pour hydrater et réparer, Masque Démêlant Nat'yrel sans silicone ni sulfate. Formats 300 ml. Livraison gratuite en Point Relais en France.",
    intro: `Une fois par semaine, offrez à vos cheveux un vrai temps de soin. Le Masque Suprême hydrate, répare et fait rayonner la chevelure en un seul geste, tandis que le Masque Démêlant Nat'yrel, sans silicone, parabène, sulfate ni petrolatum, facilite le démêlage en douceur. ${SHIP}`,
    match: (p) => (p.collections || []).includes("masques"),
    manual: true,
    order: ["masque-supreme", "masque-demelant-natyrel"],
    sections: [{ id: "masques", title: "Nos masques", filter: () => true }],
    cols: "sm:grid-cols-2 md:grid-cols-3",
  },
  "huiles-serums": {
    path: "/huiles-serums",
    name: "Huiles & sérums",
    h1Sub: "pour cheveux afro, crépus et barbe",
    eyebrow: "Les concentrés",
    title: "Huiles et sérums pour cheveux, locks et barbe | Ozentya",
    description: "Huiles et sérums Ozentya : Sérum Extrême Repouss pour la pousse des cheveux, Sérum Reconstructeur, Huile Locks et Huile à Barbe. Livraison gratuite en Point Relais en France.",
    intro: `Concentrés et précis, nos sérums et nos huiles agissent au plus près du cuir chevelu, des longueurs, des locks ou de la barbe. La lotion Extrême Repouss, aussi disponible en version cheveux fins, prend soin du cuir chevelu et des cheveux fragilisés ; le Sérum Reconstructeur lisse, protège de la chaleur et répare. Côté huiles, l'Huile Locks apporte nutrition et éclat naturel, l'Huile à Barbe hydratation et douceur. ${SHIP}`,
    match: (p) => (p.collections || []).includes("huiles-serums"),
    manual: true,
    order: ["extreme-repouss", "extreme-repouss-cheveux-fins", "serum-reconstructeur", "huile-locks", "huile-barbe"],
    sections: [
      { id: "serums", title: "Sérums & lotions", filter: (p) => !/huile/i.test(p.name) },
      { id: "huiles", title: "Huiles", filter: (p) => /huile/i.test(p.name) },
    ],
    cols: "sm:grid-cols-2 md:grid-cols-3",
  },
};

export const COLLECTION_LINKS = Object.values(COLLECTIONS).map((c) => ({ to: c.path, label: c.name }));

export const collectionOf = (p) => (p ? Object.values(COLLECTIONS).find((c) => c.match(p)) : undefined);

const rank = (c, p) => { const i = (c.order || []).indexOf(p.slug); return i < 0 ? 999 : i; };

export function collectionProducts(c, all) {
  return all.filter(c.match).sort((a, b) => rank(c, a) - rank(c, b));
}
